import { useMemo, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { OpenInFull } from "@mui/icons-material";
import dayjs from "dayjs";
import ToDoListItem from "./ToDoListItem";

const FALLBACK_TITLE = "Untitled To-do";

function getCompletedAt(item) {
  return (
    item.completed_at ||
    item.completed_dt ||
    item.completed_on ||
    item.completed ||
    item.updated_at ||
    item.modified_at ||
    item.created_at
  );
}

export default function CompletedToDoItemRow({ item, folders }) {
  const [isOpen, setIsOpen] = useState(false);
  const completedAt = getCompletedAt(item);
  const title = item.template?.title || item.title || FALLBACK_TITLE;

  const completedLabel = useMemo(() => {
    if (!completedAt) {
      return "Completed time unavailable";
    }
    const parsed = dayjs(completedAt);
    return parsed.isValid()
      ? parsed.format("MMM D, YYYY h:mm A")
      : "Completed time unavailable";
  }, [completedAt]);

  return (
    <>
      <Box
        sx={{
          px: 1,
          py: 0.75,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
        }}
      >
        <Stack spacing={0.25} sx={{ minWidth: 0 }}>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {title}
          </Typography>
          <Typography variant="caption" sx={{ color: "text.secondary" }}>
            Completed {completedLabel}
          </Typography>
        </Stack>
        <IconButton
          size="small"
          aria-label="View completed item"
          onClick={() => setIsOpen(true)}
        >
          <OpenInFull fontSize="small" />
        </IconButton>
      </Box>

      <Dialog open={isOpen} onClose={() => setIsOpen(false)} fullWidth>
        <DialogContent sx={{ px: 1, pt: 2 }}>
          <ToDoListItem
            item={item}
            completed={Boolean(item.is_complete)}
            onToggleComplete={() => {}}
            questionResult={item.question_result}
            onAnswer={() => {}}
            loading={false}
            onItemUpdated={() => {}}
            divider={false}
            folders={folders}
            onMoveToFolder={() => {}}
            readOnly
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
